import { get } from '@namespace/helpers';
import { IGamesProvider } from '../../../types';

export const getProviders = (): Promise<IGamesProvider[]> =>
  get('/adm-gw01/public/gamesProviders');
